export default __webpack_public_path__ + "static/media/95.b4edd6cc.png";